export interface SentryReplaySampleRates {
  session: number
  onError: number
}

export interface SentryReplayOptions {
  feedbackEnabled: boolean
  rates: SentryReplaySampleRates
}

function parseBooleanFlag(raw: unknown): boolean {
  return typeof raw === 'string' && raw.trim().toLowerCase() === 'true'
}

function parseSampleRate(raw: unknown): number {
  if (typeof raw !== 'string') return 0
  const trimmed = raw.trim()
  if (trimmed === '') return 0
  const parsed = Number(trimmed)
  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) return 0
  return parsed
}

export function sentryReplayOptions(env: Record<string, unknown>): SentryReplayOptions {
  return {
    feedbackEnabled: parseBooleanFlag(env.VITE_SENTRY_REPLAY_FEEDBACK_ENABLED),
    rates: sentryReplaySampleRates(env),
  }
}

export function sentryReplaySampleRates(env: Record<string, unknown>): SentryReplaySampleRates {
  return {
    session: parseSampleRate(env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE),
    onError: parseSampleRate(env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE),
  }
}

export function sentryReplayEnabled(options: SentryReplayOptions): boolean {
  return options.feedbackEnabled || options.rates.session > 0 || options.rates.onError > 0
}
